export type CompletionTimeParts = {
  unit: "weeks" | "months";
  count: number;
};

export const getCompletionTimeParts = (
  weeksToComplete?: number,
): CompletionTimeParts | null => {
  if (!weeksToComplete || weeksToComplete <= 0) return null;

  if (weeksToComplete <= 8) {
    return { unit: "weeks", count: weeksToComplete };
  }

  return { unit: "months", count: Math.ceil(weeksToComplete / 4) };
};

/**
 * English completion-time copy for analytics and non-UI callers.
 * UI should use `useCompletionTimeText` so the string follows locale.
 */
export function getCompletionTimeText(
  weeksToComplete?: number,
  includeToComplete: boolean = true,
): string | null {
  const parts = getCompletionTimeParts(weeksToComplete);
  if (!parts) return null;

  const suffix = includeToComplete ? " to complete" : "";
  const unitLabel =
    parts.unit === "weeks"
      ? `week${parts.count !== 1 ? "s" : ""}`
      : `month${parts.count !== 1 ? "s" : ""}`;

  return `${parts.count} ${unitLabel}${suffix}`;
}
